import { Label } from '@/shared/models/view/labels-viewmodel';
import { IDictionary } from '@/shared/models/interface/dictionary-model';
import { Message } from '../view/message-viewmodel';
import { Popup } from '../view/popup-viewmodel';

export interface RootState {
    labels: IDictionary<Label[]>,
    popupComponent?: Popup,
    messages: Message[],
    errors: []
}

export const State: RootState = {
    labels: {},
    popupComponent: undefined,
    messages: [],
    errors: []
}